import { Component, OnDestroy, Input, ViewChild, Inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs/Subscription";
import { UserState } from "../../app/store/reducers/user.reducer";
import { AppState } from "../../app/models/app.state";
import { Navbar, App } from "ionic-angular";
import { OnInit } from "@angular/core/src/metadata/lifecycle_hooks";
import {
  ENV_VARS,
  EnvironmentVariables,
  envTypes
} from "../../app/environment-variables/environment-variables.module";
import { HomePage } from "../../pages/home.page/home.page";
import { ConfigState } from "../../app/store/reducers/config.reducer";
import { AlertController } from "ionic-angular/components/alert/alert-controller";

@Component({
  selector: "page-header",
  templateUrl: "page-header.component.html"
})
export class PageHeader implements OnDestroy, OnInit {
  userSubscription: Subscription;
  configSubscription: Subscription;
  userState: UserState;
  configState: ConfigState;
  logoByEnv: { [key in envTypes]: string } = {
    prod: "assets/imgs/logo.png",
    dev: "assets/imgs/logo_dev.png",
    test: "assets/imgs/logo_test.png",
    kih: "assets/imgs/logo_kih.png"
  };
  logoUrl: string = "assets/imgs/logo.png";
  @Input() backBtnFunction: () => void;
  @ViewChild(Navbar) navbar: Navbar;
  constructor(
    public store: Store<AppState>,
    public alertCtrl: AlertController,
    @Inject(ENV_VARS) public envVars: EnvironmentVariables,
    private app: App
  ) {
    this.userSubscription = this.store
      .select(state => state.user)
      .subscribe(user => (this.userState = user));
    this.configSubscription = this.store
      .select(state => state.config)
      .subscribe(user => (this.configState = user));
    this.logoUrl = this.logoByEnv[this.envVars.ENV] || this.logoByEnv["test"];
  }

  toHomePage() {
    const rootNav = this.app.getRootNav();
    rootNav.setRoot(HomePage);
  }

  ngOnInit() {
    if (this.backBtnFunction !== undefined) {
      // We set the backButtonClick function for the NavBar
      this.navbar.backButtonClick = this.backBtnFunction;
    }
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.configSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/page-header.component/page-header.component.ts